<template>
  <div class="about">


    <div class="card-block" style="margin-top: 18px;">

      <div class="in-bl-line">
        <div v-for="(it, ind) in brandClassify" style="width: 33.33%;display: inline-block;" class="item" @click="goDetail(it)">
          <div style="">
            <div style="padding-bottom: 100%;position: relative;">
              <img class="ab-t-t-x-y" style="width: 35%;" :src="$common.classifyImg(it.xh)"/>
            </div>

            <div style="color: #949494;font-size: 12px;line-height: 30px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">{{$common.paddingZero(it.xh)}}类-{{it.type2}}</div>
          </div>
        </div>
      </div>

    </div>


    <div style="height: 80px"></div>
  </div>
</template>
<style>

.search-wrapper-collection .van-search__content
{
  background: none;
  padding: 0;
}

.time-text
{
  font-size: 0.4rem;
  color:#000000;
}

.price-text
{
  font-size: 0.7rem;
  color:#000000;
}

.desc-text
{
  font-size: .45rem;
  color: #222222;
  line-height: .675rem;
}

</style>

<script>
import common from '../assets/js/common'
import addone from '../components/addone'
import stroe from '../store'
import _ from 'underscore'


export default {
  name: 'HelloWorld',
  props: {
    msg: String
  },
  components:
      {
        addone
      },
  data: function(){
    return {
      active:0,
      list_combine: [],
      brandClassify: [
      ]
    }
  },
  methods:{
    goAmazon()
    {
      this.$router.push({ path: '/amazon'})
    },
    goNews()
    {
      this.$router.push({ path: '/news'})
    },
    goPayment()
    {
      this.$router.push({ path: '/payment'})
    },
    goInternPayment()
    {
      this.$router.push({ path: '/payment?is_intern=1'})
    },
    openSearch()
    {
      this.$store.commit('setSearchShow',1)
    },
    initPage:function()
    {
      common.cusHttp(this,'/boot/mobile.php',{}, 'get').then((res)=>{
        res = JSON.parse(res.data)
        this.brandClassify = res.data.classify
      })
    },
    goDetail(item)
    {
      this.$router.push({ path: '/payment', query: { classify_id: item.xh }})
    },
    goService()
    {
      this.$router.push({ path: '/service'})
    },
    goRegister()
    {
      this.$router.push({ path: '/service_detail', query: { id: 5 }})
    },
    goInternRegister()
    {
      this.$router.push({ path: '/service_detail', query: { id: 37 }})
    },
    goClassify(id)
    {
      this.$router.push({ path: '/payment', query: { classify_id: id }})
    }
  },
  created:function()
  {
    /**
     * 如果没有token则跳到登录页哟
     */
    this.$emit('commitTarbar',0)
    common.checkToken(this)
    common.setTitle('热门商标');
    this.id = common.queryValue('id');
  },
  mounted()
  {
    this.$store.commit('setTarbarShow',1)
    stroe.commit('setTarbarIndex',2)
    this.initPage();
  },
  onShow()
  {
  },
  computed:{
    currentListCombine:function()
    {
      var _self = this;
      var subList = _.filter(this.list_combine,function(item){

        if( _self.active == 0 )
        {
          return true;
        }


        if ( _self.active == item.status )
        {
          return true;
        }
        return false;
      })
      console.log('合并列表')
      console.log(subList)
      return subList;
    },
  }
}
</script>
